import styles from './template.css';
import template from './template';
import {routerInstance} from '@aofl/router';
import {AoflElement, customElement, property} from '@aofl/element';

/**
 * @summary UserInitialsButton
 * @extends {AoflElement}
 */
@customElement('user-initials-button')
class UserInitialsButton extends AoflElement {
  /**
   * Creates an instance of UserInitialsButton.
   */
  constructor() {
    super();
  }

  @property({type: String})
  content = '';

  @property({type: String})
  color = '';

  @property({type: String})
  textColor = '#FFFFFF';

  @property({type: String})
  isBold = true;

  @property({type: String, attribute: true})
  id = '';

  navigate(href) {
    // eventually pop the user modal
  }

  /**
   * @readonly
   */
  static is = 'user-initials-button';

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default UserInitialsButton;
